import React, { createContext, useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useLocation } from 'react-router-dom';

export const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const location = useLocation();
  const [dialogs, setDialogs] = useState([]);
  const isIntroRoute = location.pathname === '/';

  const openDialog = (content, customStyles = {}) => {
    if (!content) {
      console.warn('[DialogContext] content 없이 openDialog가 호출되어 무시되었습니다.');
      return null;
    }

    const dialogId = Date.now(); // 고유 ID 생성
    const newDialog = { id: dialogId, content, customStyles };

    console.log('[DialogContext] openDialog', {
      dialogId,
      path: location.pathname,
      currentDialogCount: dialogs.length,
      contentType: typeof content,
      hasCustomOverlay: !!customStyles?.overlay,
      hasCustomContent: !!customStyles?.content
    });
    console.trace('[DialogContext] openDialog stack trace');

    setDialogs(prev => [...prev, newDialog]);
    return dialogId;
  };

  const closeDialog = (dialogId) => {
    console.log('[DialogContext] closeDialog', {
      dialogId: dialogId || '(latest)',
      path: location.pathname,
      currentDialogCount: dialogs.length
    });

    if (dialogId) {
      // 특정 다이얼로그 닫기
      setDialogs(prev => prev.filter(dialog => dialog.id !== dialogId));
    } else {
      // 가장 최근 다이얼로그 닫기
      setDialogs(prev => prev.slice(0, -1));
    }
  };

  const closeAllDialogs = () => {
    console.log('[DialogContext] closeAllDialogs', {
      path: location.pathname,
      currentDialogCount: dialogs.length
    });

    setDialogs([]);
  };

  useEffect(() => {
    setDialogs([]);
  }, [location.pathname]);

  useEffect(() => {
    if (dialogs.length > 0) document.body.classList.add('has-dialog-open');
    else document.body.classList.remove('has-dialog-open');

    return () => {
      document.body.classList.remove('has-dialog-open');
    };
  }, [dialogs.length]);

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog, closeAllDialogs }}>
      {children}
      {!isIntroRoute && dialogs.map((dialog, index) => (
        <Modal
          key={dialog.id}
          isOpen={true}
          onRequestClose={() => closeDialog(dialog.id)}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1000 + index, // 각 다이얼로그의 z-index를 다르게 설정
              ...dialog.customStyles?.overlay
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              padding: '0',
              border: 'none',
              borderRadius: '8px',
              maxWidth: '90vw',
              maxHeight: '90vh',
              overflow: 'auto',
              ...dialog.customStyles?.content
            }
          }}
        >
          {dialog.content}
        </Modal>
      ))}
    </DialogContext.Provider>
  );
};